export default __webpack_public_path__ + "static/media/img_04.630345cb.png";